import { connect } from 'react-redux';
import TableKlasifikasi from '../../../views/Library/TableKlasifikasi/TableKlasifikasi.library.view';
import { getStudent } from '../../../states/thunks/student.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(TableKlasifikasi);
